import { createApp } from 'vue';
import { createAgonI18n } from '../../i18n';
import PrintList from './PrintList.vue';

declare const rootProps: never;

const i18n = createAgonI18n(rootProps['culture']);

createApp(PrintList, rootProps).use(i18n).mount('#print-list');
